import { getActivePinia } from "pinia"
export default defineNuxtRouteMiddleware(async to => {
    const pinia = getActivePinia()
    const kimStore = useKimStore(pinia)
    const store = useMainStore(pinia)
    if (!to.params.skupinaMetrikKod) {
        const localePath = useLocalePath()
        if (kimStore.filteredMetrikyTree.length === 0) {
            await callOnce(() => kimStore.fetchMetrikyAndIndikatory())
        }
        if (store.mobileMode) {
            store.mobileLeftPanelOpen = true
        }
        return navigateTo(
            localePath("/cisla/katalog-indikatoru-a-metrik/m.0300.05.003")
        )
    }
})
